import { render, staticRenderFns } from "./AppraisalReviews.vue?vue&type=template&id=ac1d97b2"
import script from "./AppraisalReviews.vue?vue&type=script&lang=js"
export * from "./AppraisalReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports